module.exports = __webpack_public_path__ + "static/media/30wkndbaseball.e4c85429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30wkndbaseball.png
// module id = 125
// module chunks = 0